import React, { useRef, useEffect, useCallback, useState} from 'react';
import {WIDTH, HEIGHT, PADDING} from './constants.js';

import * as THREE from "three";
import {connect} from 'react-redux';

const Plane3Canvas = ({blur, setMacroToShow, macroToShow, parameters, selection, startDragging, coords, effect, setEffectParameterValues, ... props}) => {
    const ref = useRef(undefined);
    const scene = useRef(undefined);
    const renderer = useRef(undefined);
    const camera = useRef(undefined);
    const heartShape = useRef(undefined);
    const mesh = useRef(undefined);
    const material = useRef(undefined);
    const geometry = useRef(undefined);
    const added = useRef(false);

    useEffect(() => {
        scene.current = new THREE.Scene();
        camera.current = new THREE.OrthographicCamera( -1, 1, 1, -1, 1, 1000 );
        renderer.current = new THREE.WebGLRenderer();
        renderer.current.setSize( 300, 200);
        renderer.current.setPixelRatio(window.devicePixelRatio);
        // document.body.appendChild( renderer.domElement );
        // use ref as a mount point of the Three.js scene instead of the document.body
        draw();
        ref.current.appendChild( renderer.current.domElement );
   }, []);

    useEffect(() => {
        if (scene.current) {
            draw();
        }
    }, [
        props.selectedColor,
        coords,
        parameters,
        macroToShow,
        props.filteredParameters,
        props.isRegionMode]);

    const draw = useCallback(() => {
        heartShape.current = new THREE.Shape();
        let macro = effect.macros[0];
        let {x,y,diameter} = macro.getGeometry();
        let spline = convertCoords(macro.getBlob(x,y,16, true));
        
        let [sx, sy] = spline[0];
        heartShape.current.moveTo(sx, sy);
        for (let i=1; i < spline.length; i++ ){
            let [cx1, cy1, cx2, cy2, cx, cy] = spline[i];
            heartShape.current.bezierCurveTo(cx1, cy1, cx2, cy2, cx, cy);
        }
        
        if (geometry.current) {
            let geo = heartShape.current.makeGeometry();
            geometry.current.attributes =  geo.attributes;
        } else {
            geometry.current = new THREE.ShapeGeometry( heartShape.current );
        }
        material.current = material.current || new THREE.MeshBasicMaterial( { color: 0x00ff00 } );
        if (mesh.current) {
            mesh.current.geometry = geometry.current;
        } else {
            mesh.current = mesh.current || new THREE.Mesh( geometry.current, material.current ) ;
        }
        if (!added.current) {
            scene.current.add( mesh.current );
            added.current = true;
        }
        camera.current.position.z = window.zpos || 1;
        renderer.current.render( scene.current, camera.current );
    }, [props.selectedColor, coords, parameters, macroToShow, props.filteredParameters, props.isRegionMode]);
    
    return (<div ref={ref} className="threejs-canvas-holder">
            </div>);
};

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

const convertCoords = (spline) => {
    let coords = [];
    let [x,y] = spline[0];
    coords.push([convertCoord(x, WIDTH), convertCoord(y, HEIGHT, -1)]);
    

    for (let i=1; i < spline.length; i++ ){
        let c = [];
        for (let j=0; j < spline[i].length; j++) {
            let size = j % 2 === 0 ? WIDTH : HEIGHT;
            let flip = j % 2 === 0 ? 1 : -1;
            c.push(convertCoord(spline[i][j], size, flip));
        }
        coords.push(c);
    }
    return coords;
};

const convertCoord  = (x, size=WIDTH, flip=1) => {
    return flip * (-1 + 2*(x / size));
};

export default connect(mapStateToProps, mapDispatchToProps)(Plane3Canvas);
